import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { Img } from 'react-image';
import styles from './EmptyList.module.scss';

interface Props {
    variant: 'upcoming' | 'completed' | 'cancelled' | 'staff' | 'pendings' | 'all';
    className?: string;
}

export const BookingsNotCreated: FunctionComponent<Props> = props => {
    let image = '/images/bookings/EmptyCancelled.svg';
    let firstLine = 'Raise the woof!';
    let secondLine = 'There are currently no cancelations.';

    if (props.variant === 'upcoming') {
        image = '/images/bookings/EmptyUpcoming.svg';
        firstLine = 'Don’t get too comfy.';
        secondLine = 'This will fill up soon enough.';
    } else if (props.variant === 'completed') {
        image = '/images/bookings/EmptyCompleted.svg';
        firstLine = 'Almost there.';
        secondLine = 'Nothing completed just yet.';
    } else if (props.variant === 'staff') {
        secondLine = 'There are currently no staff issues.';
    } else if (props.variant === 'pendings') {
        secondLine = 'There are currently no pendings.';
    }

    return (
        <div className={clsx(styles.container, props.className)}>
            <Img
                className={clsx({
                    [styles.imageCancelled]: ['cancelled', 'all', 'staff', 'pending'].includes(props.variant),
                    [styles.imageCompleted]: props.variant === 'completed',
                    [styles.imageUpcoming]: props.variant === 'upcoming'
                })}
                src={image}
            />
            <p className={styles.title}>{firstLine}</p>
            <p className={styles.description}>{secondLine}</p>
        </div>
    );
};

export default BookingsNotCreated;
